import { QuestionnaireType } from "../../../utils/Types/QuestionnaireType";
import { DateTime } from "luxon";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import { Card, CardActionArea, CardContent, Chip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { NavLink } from "react-router-dom";
import { QUESTIONNAIRE_STATE_CS } from "../../../utils/QuestionnaireUtils";

interface QuestionnaireEntryType {
  questionnaire: QuestionnaireType;
}

const STATE_CHIP_COLORS: Record<string, { bg: string; color: string }> = {
  new:        { bg: "#e3f2fd", color: "#1565c0" },
  inprogress: { bg: "#fff3e0", color: "#e65100" },
  sent:       { bg: "#e8f5e9", color: "#2e7d32" },
  done:       { bg: "#e8f5e9", color: "#2e7d32" },
  returned:   { bg: "#ffebee", color: "#c62828" },
  canceled:   { bg: "#f5f5f5", color: "#616161" },
};

const QuestionnaireEntry = ({ questionnaire }: QuestionnaireEntryType) => {
  const normalizeLabel = (value: unknown, fallback: string) => {
    if (value === null || value === undefined) return fallback;
    const stringValue = String(value).trim();
    if (stringValue === "" || stringValue.toLowerCase() === "null") return fallback;
    return stringValue;
  };

  const title = normalizeLabel(questionnaire.jobTitle, "Dotazník");
  const employmentLabel = normalizeLabel(questionnaire.typeOfEmployment, "neuvedeno");

  const startDate = DateTime.fromISO(questionnaire.startDate).isValid
    ? DateTime.fromISO(questionnaire.startDate).toFormat("d.M.yyyy")
    : "neuvedeno";

  const subtitle = `${employmentLabel} • Datum nástupu: ${startDate}`;
  const stateLabel = QUESTIONNAIRE_STATE_CS[questionnaire.state] || questionnaire.state;
  const chipColors = STATE_CHIP_COLORS[questionnaire.state] ?? { bg: "#f5f5f5", color: "#616161" };

  return (
    <Card variant="outlined" sx={{ position: "relative" }}>
      <Chip
        label={stateLabel}
        size="small"
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          backgroundColor: chipColors.bg,
          color: chipColors.color,
          fontWeight: 600,
          zIndex: 1,
        }}
      />
      <CardActionArea component={NavLink} to={`/dotazniky/${questionnaire.id}/uvod`}>
        <CardContent>
          <Grid container direction="row" alignItems="center" spacing={2} wrap="nowrap">
            <Grid
              sx={{
                minWidth: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Grid
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "10px",
                  backgroundColor: "rgba(204, 0, 0, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FeedOutlinedIcon fontSize="medium" sx={{ color: "#CC0000" }} />
              </Grid>
            </Grid>
            <Grid sx={{ flex: 1, textAlign: "left", pr: 8 }}>
              <Typography sx={{ fontSize: "1.2em", fontWeight: "bold" }}>
                {title}
              </Typography>
              <Typography sx={{ color: "text.secondary" }}>
                {subtitle}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default QuestionnaireEntry;

